import { EMPTY_STRING, SYMBOL_HYPHEN } from '../../../constants/common'

export function normalizeIntegerInput({ max = null, min = null, value }) {
  const normalizedValue = value
    .replace(/[−–—]/g, SYMBOL_HYPHEN)
    .replace(/[^0-9-]/g, EMPTY_STRING)
    .replace(/(?!^)-/g, EMPTY_STRING)

  if (normalizedValue === EMPTY_STRING || normalizedValue === SYMBOL_HYPHEN) {
    return null
  }

  const normalizedNumber = Number(normalizedValue)

  if (Number.isNaN(normalizedNumber)) {
    return null
  }

  if (min !== null && normalizedNumber < min) {
    return min
  }

  if (max !== null && normalizedNumber > max) {
    return max
  }

  return normalizedNumber
}
